// Generated by purs version 0.15.15
var otherwise = true;
export {
    otherwise
};
